export default "__VITE_ASSET__iXkTZh8eFDyurYVIc3bOFg__"